import { render, staticRenderFns } from "./organization-details.vue?vue&type=template&id=685961c2"
import script from "./organization-details.vue?vue&type=script&lang=js"
export * from "./organization-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports